<template>
  <div class="h-screen">
    <div id="app" class="page-container">
      <div class="content-wrapper bg-cover" :style="bgStyle">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useThemeStore } from "@/stores/theme";
const themeStore = useThemeStore();

const bgStyle = computed(() =>
  themeStore.currentTheme === "dark"
    ? { background: "#131313" }
    : { background: "#f3f1e5" }
);
</script>

<style scoped>
#app {
  color: #2c3e50;
  height: 100%;
}

.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.content-wrapper {
  flex: 1;
}

:deep(.p-button:focus),
:deep(.p-button:focus-visible) {
  box-shadow: none !important;
  outline: none !important;
}
</style>
